import { object, string } from 'yup'
export { provider as baseURL } from 'constants/apiBaseUrls'

export const Schema = object().shape({
  messageId: string().required(),
})

export const url = ({ messageId }) => `/v1/chats/${messageId}/view`
